import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, RequiredValidator, Validators } from '@angular/forms';
import { EUserType } from 'src/app/micro-services/user/enum/e-user-type';
import { User } from 'src/app/micro-services/user/models/user';
import { UserCoach } from 'src/app/micro-services/user/models/user-coach';
import { UserFactory } from 'src/app/micro-services/user/user-factory';
import { ApiProviderService } from 'src/app/services/api-provider.service';


@Component({
  selector: 'app-coachform',
  templateUrl: './coachform.component.html',
  styleUrls: ['./coachform.component.scss'],
})
export class CoachformComponent implements OnInit {

  @Output() creationCoachEvent = new EventEmitter<string>();
  @Input() title : string = "Ajouter un coach";
  @Input() isEdit: string;
  @Input() coachString: string;
  coach: UserCoach;
  coachForm: FormGroup;
  @Output() editCoachEvent = new EventEmitter<string>();

  constructor(
    private builder : FormBuilder,
    private apiProvider : ApiProviderService,
    private userFactory : UserFactory
  ) {
   
  }

  ngOnInit() {
    if (this.isEdit == "false") {
      this.coachForm = this.builder.group({
        // id: new FormControl('',[Validators.required]),
        userName: new FormControl('',[]),
        picture : new FormControl('',[]),
        updateDate : new FormControl('',[]),
        phoneNumber : new FormControl ('',[]),
        siret : new FormControl ('',[Validators.required]),
        email : new FormControl ('',[Validators.required])
      });
    }else{
      this.coach = JSON.parse(this.coachString)
      this.coachForm = this.builder.group({
        // id: new FormControl('',[Validators.required]),
        userName: new FormControl(this.coach.userName,[]),
        picture : new FormControl(this.coach.picture,[]),
        updateDate : new FormControl(this.coach.updateDate,[]),
        phoneNumber : new FormControl (this.coach.phoneNumber,[]),
        siret : new FormControl (this.coach.compagnyNumber,[Validators.required]),
        email : new FormControl (this.coach.email,[Validators.required])
      });
    }
  }
  
  validate(){
    if (this.coachForm.invalid) {
      this.coachForm.markAllAsTouched();
      return;
    }
    
    let coach : UserCoach = this.userFactory.createFromType(EUserType.Coach) as UserCoach;
    coach.userName = this.coachForm.controls.userName.value;
    coach.picture = this.coachForm.controls.picture.value;
    coach.updateDate = this.coachForm.controls.updateDate.value;
    coach.phoneNumber = this.coachForm.controls.phoneNumber.value;
    coach.compagnyNumber = this.coachForm.controls.siret.value;
    coach.email = this.coachForm.controls.email.value;    

     this.apiProvider.createCoach(coach).subscribe(
      (res) => {
        this.addNewCoach(res);
      }
     );
    
  }

  addNewCoach(coach: string){
    const c = JSON.stringify(coach);
    this.creationCoachEvent.emit(c)
  }

  coachEdited(coach: string){
    const c = JSON.stringify(coach);
    this.editCoachEvent.emit(c);
  }

  testType(){
    if (this.isEdit == "false") {
      this.validate();
    }
    else{
      this.coach.userName = this.coachForm.controls.userName.value;
      this.coach.picture = this.coachForm.controls.picture.value;
      this.coach.updateDate = this.coachForm.controls.updateDate.value;
      this.coach.phoneNumber = this.coachForm.controls.phoneNumber.value;
      this.coach.compagnyNumber = this.coachForm.controls.siret.value;
      this.coach.email = this.coachForm.controls.email.value;
      this.apiProvider.editCoach(this.coach).subscribe(
        (res) => { 
          this.coach = res;
          this.coachEdited(res);
        },
      );
    }
  }
}
